__turbopack_context__.v({
  "body": "PerformanceLabIndiaPurchaseModal-module__P_6fQq__body",
  "copyBlock": "PerformanceLabIndiaPurchaseModal-module__P_6fQq__copyBlock",
  "description": "PerformanceLabIndiaPurchaseModal-module__P_6fQq__description",
  "modalButton": "PerformanceLabIndiaPurchaseModal-module__P_6fQq__modalButton",
  "modalRoot": "PerformanceLabIndiaPurchaseModal-module__P_6fQq__modalRoot",
  "title": "PerformanceLabIndiaPurchaseModal-module__P_6fQq__title",
});
